import Vue from 'vue';

// Shared reactive state backing the single, app-wide <ConfirmDialog /> in App.vue.
// Vue.observable makes plain objects reactive outside of a component's own data().
export const confirmState = Vue.observable({
  show: false,
  title: 'Please confirm',
  message: '',
  confirmText: 'Delete',
  resolve: null,
});

// Usage in any component: const ok = await this.$confirm('Delete this item?');
Vue.prototype.$confirm = function (message, options = {}) {
  confirmState.title = options.title || 'Please confirm';
  confirmState.message = message;
  confirmState.confirmText = options.confirmText || 'Delete';
  confirmState.show = true;

  return new Promise((resolve) => {
    confirmState.resolve = resolve;
  });
};
